import {get} from '@/lib/request'

function locationsPath() {
  return '/wp/v2/locations'
}

export function listLocations() {
  return get(`${locationsPath()}?_embed`)
}
